$(function(){
  $("#rb-photo-btn").on("click", function(e){
    e.preventDefault()
    e.stopPropagation()
    $("#rb-photo").click()
  })
  
  $("#rb-photo").on("change", function(){
    if($(this)[0].files[0]) {
      var reader = new FileReader();
      reader.onload = function(e) {
        $("#rb-photo-preview").attr("src", e.target.result)
        $("#rb-photo-preview").show();
      }
      reader.readAsDataURL($(this)[0].files[0]);
    }
  })
  
  // Handle photo deletion with confirmation
  $(document).on("click", "#delete-photo-btn", function(e){
    if(!confirm("写真を削除してもよろしいですか？\n\n削除した写真は元に戻せません。")) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  })
})